// extracted by mini-css-extract-plugin
export var banner = "_gt-0";
export var closeButton = "_gt-2";
export var greenCheckmark = "_gt-3";
export var hereLink = "_gt-4";
export var titleIcon = "_gt-1";